// extracted by mini-css-extract-plugin
module.exports = {"LinksList":"styles_LinksList__1jdoM","LinksList-title":"styles_LinksList-title__1updP","LinksList-items":"styles_LinksList-items__eeo14"};